import React, {Component} from 'react';

import Content from '../../components/Content/Content'
import Error404 from '../../components/Error404/Error404'

import {
    Container
} from 'reactstrap'

export default class Error404Container extends Component {
    render() {
        return (
            <div className={'main-wrapper'}>
                <Content>
                    <Container>
                        <Error404/>
                    </Container>
                </Content>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/public/Error404Container.js